import { z } from 'zod'

import { BooleanDtoSchema } from '@hcr/api/shared'

export const UserExistenceDtoSchema = z.strictObject({
  is_existing: BooleanDtoSchema,
})

export type UserExistenceDto = z.infer<typeof UserExistenceDtoSchema>
